import useDocumentsByOwner from './useDocumentsByOwner';

export { useDocumentsByOwner };
